import { ENDPOINT } from "./FormData";

export class ResetPasswordData {
    static instance: ResetPasswordData = new ResetPasswordData()

    /**
     * Checks if a user is registered with the given email address.
     * 
     * @param emailAddress - The user's email address to check
     * @param ifRegistered - Callback to call if the user is registered
     * @param ifNotRegistered - Callback to call if the user is not registered     
     */
    isUserRegistered(
        emailAddress: string,
        ifRegistered: (data: any) => void,
        ifNotRegistered: () => void
    ): void {

        const queryParams = new URLSearchParams({
            email: emailAddress,
            cell: "+11111111111" // Placeholder, not used in this context
        });

        const url = `${ENDPOINT}/isalreadyregistered?${queryParams.toString()}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                // Call the provided callback with the parsed JSON content
                if (data.email_registered) {
                    ifRegistered(data);
                } else {
                    ifNotRegistered();
                }

            })
            .catch(err => {
                console.log(err)
            })
    }

    /**
     * Sends an email to the user with a link to reset password.
     * 
     * @param emailAddress - The user's email address
     * @param patientID - The patient's ID
     * @param whenSuccess - Callback to call when the email is sent successfully
     * @param whenFailed - Callback to call when the email sending fails
     */
    sendResetPasswordEmail(
        emailAddress: string,
        patientID: string,
        whenSuccess: () => void,
        whenFailed: () => void
    ): void {
        const queryParams = new URLSearchParams({
            email: emailAddress,
            patientID: patientID
        });

        const url = `${ENDPOINT}/sendresetpasswordurl/v2?${queryParams.toString()}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.ok) {
                    whenSuccess()
                } else {
                    whenFailed()
                }
            })
            .catch(err => {
                console.log(err);
                whenFailed();
            })
    }

    /**
     * Updates the user's password using the provided token and new password.
     * 
     * @param token - The reset password token
     * @param password - The new password to set
     * @param callbackSuccess - Callback to call when the password is updated successfully
     * @param callbackFail - Callback to call when the password update fails
     */
    saveNewPassword(
        token: string,
        password: string,
        callbackSuccess: () => void,
        callbackFail: () => void
    ): void {
        const submitData = {
            token: token,
            password: password
        }

        fetch(`${ENDPOINT}/resetpassword/v2`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(submitData)
        })
            .then(response => {
                console.log(response)
                callbackSuccess()
            })
            .catch(e => {
                console.log('Network Issue: ' + e)
                callbackFail()
            })
        console.log("submitted", submitData)
    }
}
